import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { InputLabel, MenuItem, FormControl, Select } from '@material-ui/core'
import { ActivitiesType } from '@tabeeb/contracts/main-api/swagger-main-api'

import { ActivitiesTypeDisplayName } from '../../enums'

import './styles.less'

const ActivityTypeFilter = ({ activityType, handleSelectActivityTypeFilter }) => {
  const options = useMemo(() => {
    const types = [
      ActivitiesType.All,
      ActivitiesType.AIFlag,
      ActivitiesType.Flag,
      ActivitiesType.Drawing,
      ActivitiesType.Image,
      ActivitiesType.Shape,
      ActivitiesType.Text,
      ActivitiesType.Audio,
    ]

    return types.map((type) => ({
      value: type,
      name: ActivitiesTypeDisplayName[type],
    }))
  }, [])

  return (
    <div className='activity-filters-item activity-filters-type'>
      <FormControl className='activity-filters-item-control'>
        <InputLabel>Type</InputLabel>
        <Select
          value={activityType}
          onChange={handleSelectActivityTypeFilter}
          MenuProps={{ id: 'activity-filters-menu' }}
        >
          {options.map((option) => (
            <MenuItem value={option.value} key={option.value}>
              <span className='activity-filters-menu-text' title={option.name}>
                {option.name}
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

ActivityTypeFilter.propTypes = {
  activityType: PropTypes.number.isRequired,
  handleSelectActivityTypeFilter: PropTypes.func.isRequired,
}

export default ActivityTypeFilter
